import { getFileType } from './fileTypeUtils';

export const OVERWRITE_REUPLOAD_EXTENSIONS = ['html', 'json', 'js', 'css'] as const;
export const OVERWRITE_REUPLOAD_ACCEPT = OVERWRITE_REUPLOAD_EXTENSIONS.map(ext => `.${ext}`).join(',');

const getNormalizedExtension = (fileName = '') => {
  return getFileType('', fileName).toLowerCase();
};

export const isOverwriteReuploadExtension = (fileName = '') => {
  const extension = getNormalizedExtension(fileName);
  return OVERWRITE_REUPLOAD_EXTENSIONS.includes(extension as typeof OVERWRITE_REUPLOAD_EXTENSIONS[number]);
};

export const canOverwriteReupload = (fileName = '', storageType?: string) => {
  return storageType !== 'TEMPORARY' && isOverwriteReuploadExtension(fileName);
};

export const hasMatchingOverwriteReuploadExtension = (selectedFileName = '', targetFileName = '') => {
  const selectedExtension = getNormalizedExtension(selectedFileName);
  const targetExtension = getNormalizedExtension(targetFileName);

  if (!selectedExtension || !targetExtension) {
    return false;
  }

  return isOverwriteReuploadExtension(targetFileName) && selectedExtension === targetExtension;
};
